export const services6 = [
  {
    width: 48,
    height: 64,
    path: "M47.7 23.5h-10V5.8c0-1.6-1.3-2.8-2.8-2.8H5.8C4.3 3 3 4.3 3 5.8v29.7c0 1.6 1.3 2.8 2.8 2.8h10v10c0 1.6 1.3 2.8 2.8 2.8h29.1c1.6 0 2.8-1.3 2.8-2.8V26.4c.1-1.6-1.2-2.9-2.8-2.9zm-34.7-9.3h-4.2v-4.2h4.2v4.2zm0 8.3h-4.2v-4.2h4.2v4.2zm0 8.3h-4.2v-4.2h4.2v4.2zm11.1-16.6h-4.2v-4.2h4.2v4.2zm0 8.3h-4.2v-4.2h4.2v4.2zm0 8.3h-4.2v-4.2h4.2v4.2zm11.1-16.6h-4.2v-4.2h4.2v4.2zm0 8.3h-4.2v-4.2h4.2v4.2zm0 8.3h-4.2v-4.2h4.2v4.2zm11.1 16.7h-4.2v-4.2h4.2v4.2zm0-8.4h-4.2v-4.2h4.2v4.2z",
    key: "web",
    image: "/assets/img/webdesign.jpg",
  },
  {
    width: 48,
    height: 64,
    path: "M36 0H12C5.4 0 0 5.4 0 12v40c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12zm-24 4h24c4.4 0 8 3.6 8 8v40c0 4.4-3.6 8-8 8H12c-4.4 0-8-3.6-8-8V12c0-4.4 3.6-8 8-8z M24 56c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z",
    key: "mobile",
    image: "/assets/img/mobiledesign.jpg",
  },
  {
    width: 48,
    height: 64,
    path: "M44 0H4C1.8 0 0 1.8 0 4v56c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm-4 56H8V8h32v48z M16 16h16v4H16z M16 24h16v4H16z M16 32h16v4H16z",
    key: "backend",
    image: "/assets/img/server.jpg",
  },
  {
    width: 48,
    height: 64,
    path: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24 24-10.7 24-24S37.3 0 24 0zm0 44c-11 0-20-9-20-20S13 4 24 4s20 9 20 20-9 20-20 20zm8-22c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z",
    key: "ai",
    image: "/assets/img/aichat.jpg",
  },
  {
    width: 48,
    height: 64,
    path: "M44 16L24 0 4 16v32l20 16 20-16V16zm-20 4c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0 24c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12z",
    key: "blockchain",
    image: "/assets/img/blockchain.jpg",
  },
  {
    width: 48,
    height: 64,
    path: "M42 48h-4V24c0-1.1-.9-2-2-2H24v-4h4c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h4v4H12c-1.1 0-2 .9-2 2v24H6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h-4V26h20v22h-4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2z",
    key: "bms",
    image: "/assets/img/business_software.jpg",
  },
];
